if (!customElements.get('animated-image')) {
  customElements.define('animated-image', class AnimatedImage extends HTMLElement {
    constructor() {
      super();
      this.addListeners();
    }

    addListeners() {
      window.addEventListener('scroll', this.activateAnimation.bind(this));
      window.addEventListener('load', this.activateAnimation.bind(this));
    }

    activateAnimation() {
      if (this.isInViewport(this)) {
        this.classList.add('in-view');
        window.removeEventListener('scroll', this.activateAnimation);
      }
    }

    isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top < window.innerHeight && rect.bottom > 0
      );
    }
  });
}
